<template lang="pug">
    div
        h2 Buscador por id venta
        v-btn(@click="getSale") simulate search 

</template>

<script>
import apiSale from '@/services/API/Sale' //sacar 
import { mapActions } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function(){
        return {
            id:2,
        }
    },
    computed: {},
    methods: {
        ...mapActions('CashDeskModule',{
            setSale:'setSale'
        }),
       async getSale(){
            //alert('im here ')
            let data= await apiSale.fetchSale()
            console.log(data)
            console.log(data.exent_total)
            this.setSale(data)
            // console.log(apiSale.fetch())
            // console.log('im here')
        }
    },
    watch: {},
    components: {
        
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>